// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"d1c76bf1","605":"8ff85964","725":"0787e439"}[chunkId] + ".chunk.js";
};